import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import PaymentOption from '../component/PaymentOption';

function Pay() {
    return (
        <div className="Card-container">
            <PaymentOption />
        </div>
    );
}

const mapStateToProps = () => ({});

export default compose(connect(mapStateToProps), withRouter)(Pay);
